import type { MouseEventHandler } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import AdditionalGuestsMessage from './AdditionalGuestsMessage'
import AdditionalGuestsModal from './AdditionalGuestsModal'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'
import ModalContext from 'contexts/ModalContext'
import ContactContext from 'contexts/contactContext'

interface Props {
  complex?: boolean
  heading?: string
  description: string
  modalContent?: string
  triangleWarning?: boolean
}

function AdditionalGuestsPopup({
  complex,
  heading,
  description,
  modalContent,
  triangleWarning,
}: Props) {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const showModal = useContext(ModalContext)
  const toggleModalCallback = useCallback<MouseEventHandler<HTMLButtonElement>>((e) => {
    e.preventDefault()
    showModal(<AdditionalGuestsModal
      description={modalContent}
      currentContact={currentContact}
    />)
  }, [currentContact, modalContent, showModal])

  const detailsLabel = intl.formatMessage({
    id: '1WZCVykKZSmzjPu5Vxj1',
    defaultMessage: 'Details',
  })

  return <>
    {complex && <MessageBanner
      kind="warning"
      icon={triangleWarning ? <LineExclamationTriangleIcon /> : undefined}
      heading={heading}
      secondaryActionButtonProps={modalContent ? { onClick: toggleModalCallback, children: detailsLabel } : undefined}
    >
      {description}
    </MessageBanner>}

    {!complex && <AdditionalGuestsMessage
      message={description}
      onClick={modalContent ? toggleModalCallback : undefined}
    />}
  </>
}

export default AdditionalGuestsPopup
